import { useQuery } from '@tanstack/react-query';
import { addressApi } from '@/api/addressApi';

export function useCountries() {
  return useQuery({
    queryKey: ['addresses', 'countries'],
    queryFn: addressApi.getCountries,
    staleTime: Infinity, // dữ liệu tĩnh, không cần refetch
  });
}

export function useProvinces(countryId?: number) {
  return useQuery({
    queryKey: ['addresses', 'provinces', countryId],
    queryFn: () => addressApi.getProvinces(countryId!),
    enabled: !!countryId,
    staleTime: Infinity,
  });
}

export function useDistricts(provinceId?: number) {
  return useQuery({
    queryKey: ['addresses', 'districts', provinceId],
    queryFn: () => addressApi.getDistricts(provinceId!),
    enabled: !!provinceId,
    staleTime: Infinity,
  });
}

export function useWards(districtId?: number) {
  return useQuery({
    queryKey: ['addresses', 'wards', districtId],
    queryFn: () => addressApi.getWards(districtId!),
    enabled: !!districtId,
    staleTime: Infinity,
  });
}
